"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.knowledge.exceeded': '已达到知识条目限制。升级您的计划以添加更多条目。',
    'limits.knowledge.limitReached': '知识限制：{limit}（升级以添加更多）',
};
